import {formatLocalizedDateMonth} from '@hconnect/uikit/src/common/utils/dateformatting'
import {Moment} from 'moment-timezone'
/**
 *
 * function to return localized date time, example: "ddd DD/MM, HH:mm"
 * (short day name, day of month, hours and minutes)
 */
export const getDayAndMonthWithTimezone = (
  datetime: Moment,
  timezoneId: string,
  locale: string
): string => {
  const utcOffset = datetime.tz(timezoneId).utcOffset()
  const dateWithUTCOffset = datetime.clone().add(utcOffset, 'minutes')
  return formatLocalizedDateMonth(dateWithUTCOffset, locale)
}

export const adjustEnLocale = (language: string): string => (language === 'en' ? 'en-GB' : language)
